const css = `.JRi9cG__carousel{height:100%;overflow:scroll}.JRi9cG__carousel .JRi9cG__card{flex:none;padding:5% 0 5% 5%}.JRi9cG__carousel .JRi9cG__card .JRi9cG__content{height:100%;border-radius:6px;box-shadow:0 1px 6px #0000001a}.JRi9cG__carousel .JRi9cG__card input[type=radio]{display:none}.JRi9cG__carousel .JRi9cG__card:last-of-type{padding-right:5%}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"carousel":"JRi9cG__carousel","content":"JRi9cG__content","card":"JRi9cG__card"};
